import * as React from "react";
import { connect } from "react-redux";
import { Action, Dispatch } from "redux";
import { InjectedFormProps, formValueSelector, reduxForm } from "redux-form";
import { AppState } from "../../../../store/app_state";

import { RefObject } from "react";

import { frontEndConfig } from "../../../../../config/config";

import StickyBottomWrapper from "../../../../common/atom/wrapper/sticky_bottom_wrapper";
import MessagePost from "../../../../common/organism/message_room/message_post";

const uploadFileMaxSize = frontEndConfig.uploadFileMaxSize;

interface IStateProps {
  initialValues:
    | {
        fileURLFileObject?: File;
      }
    | undefined;
  formValues: any;
}

interface IProps extends IStateProps {
  textareaRef: RefObject<HTMLTextAreaElement>;
  defaultMessage: string;
}

interface IState {
  image: string | null;
  imageError: string | null;
}

const validate = (values: any) => {
  const errors: any = {};
  return errors;
};

export class ClientMessageRoomForm extends React.Component<
  IProps & InjectedFormProps<{}, IProps>,
  IState
> {
  constructor(props: IProps & InjectedFormProps<{}, IProps>) {
    super(props);

    this.state = {
      image: null,
      imageError: null,
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleKeyboardEvent = this.handleKeyboardEvent.bind(this);
  }

  public componentWillMount(): void {
    this.props.initialize({ message: this.props.defaultMessage });
  }

  public render(): JSX.Element {
    const { invalid, handleSubmit, pristine, submitting, error, textareaRef } =
      this.props;

    return (
      <StickyBottomWrapper>
        <form
          name="clientMessageRoomForm"
          onSubmit={handleSubmit}
          onKeyDown={this._handleKeyboardEvent}
        >
          <MessagePost
            onchange={this.handleOnChange}
            textareaRef={textareaRef}
            disabled={pristine || submitting || invalid}
            imageError={this.state.imageError}
            formValues={this.props.formValues}
            error={error}
          />
        </form>
      </StickyBottomWrapper>
    );
  }

  private _handleKeyboardEvent = (ev: any) => {
    this.handleKeyboardEvent(ev, this.props.handleSubmit);
  };

  private handleKeyboardEvent(e: React.KeyboardEvent<HTMLElement>, cb: any) {
    if (e.metaKey && e.key === "Enter") {
      cb();
    }
  }

  private handleOnChange(e: any) {
    const target: HTMLInputElement = e.target as HTMLInputElement;
    const file: File | null = target.files ? target.files.item(0) : null;
    // 同じファイルの連続した呼び出しに対応する為に、inputのValueをリセット
    target.value = "";

    try {
      this.setState({ imageError: null });
      if (file) {
        if (file.size > uploadFileMaxSize) {
          throw new Error("ファイルサイズオーバ");
        } else {
          this.props.change("fileURLFileObject", file);
        }
      }
    } catch (error) {
      this.setState({ imageError: error.message });
    }
  }
}

const selector = formValueSelector("clientMessageRoomForm");

const mapStateToProps = (state: AppState) => {
  return {
    formValues: selector(state, "fileURLFileObject"),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
  return {};
};

export default reduxForm({
  form: "clientMessageRoomForm",
  validate,
})(connect(mapStateToProps, mapDispatchToProps)(ClientMessageRoomForm));



// WEBPACK FOOTER //
// ./src/presentation/component/client/message_rooms/main/client_message_room_form.tsx